import { useQuery } from "@tanstack/react-query";
import { useRepository } from '@city-sage/aurum-avis-labs-components';
import { QueryKeys } from "../lib/QueryKeys";
import { Day, StopStateEnum } from "@city-sage/core-client";

interface UseMultipleDayStopsProps {
  itineraryId: string;
  days: Day[] | undefined;
  states?: StopStateEnum[];
}

export function useMultipleDayStops({ itineraryId, days, states }: UseMultipleDayStopsProps) {
  const { api } = useRepository();
  const filter = {dayIds: days?.map(day => day.id)}

  const filterString = states ? JSON.stringify({...filter, state: states }) : JSON.stringify(filter)

  return useQuery({
    queryKey: QueryKeys.itinerary.stops(itineraryId, days?.map(day => day.id).join(','), states),
    queryFn: () => api.findAllItineraryStop({ 
      itineraryId: itineraryId, 
      sort: JSON.stringify(["index", "ASC"]),
      filter: filterString,
      // TODO this is hardcoded for now, we need to fix this
      limit: 1000
    }),
    enabled: !!itineraryId && !!days && days.length > 0,
    select: (data) => {
      
      // Group stops by dayId for easy access
      const stopsByDay = new Map<string, typeof data>();
      
      data.forEach(stop => {
        if (stop.dayIds && stop.dayIds.length > 0) {
          stop.dayIds.forEach(dayId => {
            const dayStops = stopsByDay.get(dayId) || [];
            dayStops.push(stop);
            stopsByDay.set(dayId, dayStops);
          });
        }
      });
      
      return {
        allStops: data,
        stopsByDay,
        getStopsForDay: (dayId: string) => stopsByDay.get(dayId) || []
      };
    }
  });
} 